module.exports = __webpack_public_path__ + "img/error.a28e0501.png";